// extracted by mini-css-extract-plugin
export var icon = "_qs-0";